import { render, staticRenderFns } from "./_TotalShow.vue?vue&type=template&id=128eb153"
import script from "./_TotalShow.vue?vue&type=script&lang=js"
export * from "./_TotalShow.vue?vue&type=script&lang=js"
import style0 from "./_TotalShow.vue?vue&type=style&index=0&id=128eb153&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports